"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RegisterStatusOrder = exports.RegisterStatusPresentation = exports.RegisterStatus = void 0;
exports.getRegisterStatusPresentation = getRegisterStatusPresentation;
exports.getRegisterStatusOrder = getRegisterStatusOrder;
var RegisterStatus;
(function (RegisterStatus) {
    RegisterStatus["REGISTERED"] = "REGISTERED";
    RegisterStatus["NOT_REGISTERED"] = "NOT_REGISTERED";
    RegisterStatus["NOT_REGISTERED_EDITED"] = "NOT_REGISTERED_EDITED";
    RegisterStatus["ERROR"] = "ERROR";
    RegisterStatus["ERROR_EDITED"] = "ERROR_EDITED";
    RegisterStatus["LEGACY"] = "LEGACY";
})(RegisterStatus || (exports.RegisterStatus = RegisterStatus = {}));
exports.RegisterStatusPresentation = {
    [RegisterStatus.REGISTERED]: 'Registrado',
    [RegisterStatus.NOT_REGISTERED]: 'Sin registrar',
    [RegisterStatus.NOT_REGISTERED_EDITED]: 'Sin registrar',
    [RegisterStatus.ERROR]: 'Error al registrar',
    [RegisterStatus.ERROR_EDITED]: 'Error al registrar',
    [RegisterStatus.LEGACY]: 'N/A',
};
function getRegisterStatusPresentation(status) {
    return exports.RegisterStatusPresentation[status];
}
exports.RegisterStatusOrder = {
    [RegisterStatus.REGISTERED]: 5,
    [RegisterStatus.NOT_REGISTERED]: 1,
    [RegisterStatus.NOT_REGISTERED_EDITED]: 2,
    [RegisterStatus.ERROR]: 4,
    [RegisterStatus.ERROR_EDITED]: 3,
    [RegisterStatus.LEGACY]: 6,
};
function getRegisterStatusOrder(status) {
    return exports.RegisterStatusOrder[status];
}
//# sourceMappingURL=register-status-enum.js.map